import { createI18n, type I18nOptions } from "vue-i18n";
import { parseUserLocaleCode } from "@/shared/@types/UserLocaleCode";
import { defaultLocale } from "@/shared/i18n/availableLocales";
import { PREFERRED_LOCALE_LOCAL_STORAGE_KEY } from "@/shared/i18n/preferredLocaleLocalStorageKey";
import { datetimeFormats } from "./datetimeFormats";

export const assertAvailableLocaleCode = (locale: unknown) =>
  parseUserLocaleCode(locale);

export const getBrowserLocale = () => {
  if (typeof navigator === "undefined") return undefined;

  const browserLanguage = navigator.language;
  // use i.e. 'de' instead of 'de-DE' to match available locales
  const browserLanguageShort = browserLanguage.split("-")[0];

  return (
    assertAvailableLocaleCode(browserLanguage) ??
    assertAvailableLocaleCode(browserLanguageShort)
  );
};

const getInitialLocale = () => {
  let savedLocale;
  if (typeof localStorage !== "undefined") {
    savedLocale = localStorage.getItem(PREFERRED_LOCALE_LOCAL_STORAGE_KEY);
  }

  return (
    assertAvailableLocaleCode(savedLocale) ??
    getBrowserLocale() ??
    defaultLocale.code
  );
};

export function setupI18n(options: I18nOptions) {
  const initialLocale = getInitialLocale();
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", initialLocale);
  }

  return createI18n<false>({
    fallbackLocale: defaultLocale.code,
    legacy: false,
    locale: initialLocale,
    datetimeFormats,
    ...options,
  });
}
